// azure-ml.service.ts
import { Injectable } from '@angular/core';
import {
  DetectedObject,
  DetectedObjectResponse,
} from './types/bounding-box.model';
import { HttpClient } from '@angular/common/http';
import { first } from 'rxjs/operators';
import { ProcessedImage, UnprocessedImage } from './types/lab.types';
import { APIConfig } from '../api/api-config.provider';

@Injectable({ providedIn: 'root' })
export class LabService {
  private apiServer: string;

  constructor(
    private http: HttpClient,
    private readonly apiConfig: APIConfig,
  ) {
    this.apiServer = this.apiConfig.api.url;
  }

  processImage(id: string): Promise<DetectedObjectResponse> {
    return this.http
      .post<DetectedObjectResponse>(
        `${this.apiServer}/lab/process/${id}`,
        undefined,
      )
      .pipe(first())
      .toPromise();
  }

  async getBoxes(link: string): Promise<DetectedObjectResponse> {
    return await this.http
      .get<DetectedObjectResponse>(link)
      .pipe(first())
      .toPromise();
  }

  getUnprocessedImages(): Promise<UnprocessedImage[]> {
    return this.http
      .get<UnprocessedImage[]>(`${this.apiServer}/lab/unprocessed`)
      .pipe(first())
      .toPromise();
  }

  getProcessedImages(): Promise<ProcessedImage[]> {
    return this.http
      .get<ProcessedImage[]>(`${this.apiServer}/lab/processed`)
      .pipe(first())
      .toPromise();
  }

  async saveCustomDetection(
    id: string,
    customDetection: DetectedObject[],
  ): Promise<void> {
    await this.http
      .put(`${this.apiServer}/lab/processed/${id}/custom`, customDetection)
      .pipe(first())
      .toPromise();
  }

  getLibrary(): Promise<unknown[]> {
    return this.http
      .get<unknown[]>(`${this.apiServer}/lab/library`)
      .pipe(first())
      .toPromise();
  }

  async addImage(file: File): Promise<void> {
    const formData = new FormData();
    formData.append('image', file);
    await this.http
      .post(`${this.apiServer}/lab/image`, formData)
      .pipe(first())
      .toPromise();
  }
}
